import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { map, switchMap, catchError } from "rxjs/operators";

import { UmbracoHttpClient } from "../http/umbraco-http-client.service";
import { UmbracoIndstillingerObserver } from "../umbraco-indstillinger";

@Injectable({ providedIn: "root" })
export class DriftsstatusService {
    constructor(
        private readonly umbracoHttpClient: UmbracoHttpClient,
        private readonly indstillingerObserver: UmbracoIndstillingerObserver
    ) {}

    public erDerAktuelleDriftsforstyrrelser(): Observable<boolean> {
        return this.indstillingerObserver.valueChanges.pipe(
            map((i) => i.forsyningWeb && i.forsyningWeb.nodeId),
            switchMap((nodeId) => {
                if (!nodeId) {
                    return of(false);
                }

                // Håndter fejl gracefully - hvis API'en fejler, antag at der ikke er driftsforstyrrelser
                return this.umbracoHttpClient.get(`ErDerAktuelleDriftsforstyrrelser?nodeId=${nodeId}`).pipe(
                    catchError((error) => {
                        // Log fejlen, men returner false i stedet for at kaste fejlen videre
                        // Dette forhindrer at appen crasher hvis API'en fejler (f.eks. 500 fejl eller hvis brugeren ikke er logget ind)
                        console.warn(`⚠️ Kunne ikke hente driftsstatus (nodeId: ${nodeId}):`, error?.status || error?.message || error);
                        return of(false);
                    })
                );
            })
        );
    }
}
